export const ADD_VIDEO_CONFIRM_TEXT = `Whoops... the subtitles of the video you’ve added do not coincide with the target language of your playlists.`;
export const ADD_VIDEO_NO_CAPTIONS_TEXT = `This video does not have any subtitles, please select another one.`;
